import { watchProfilingSaga } from '@topconagriculture/profiling';
import { watchCountrySaga } from '@topconagriculture/country';
import { watchLanguageSaga } from '@topconagriculture/language';

import gqlInstance from '../core/graphql/graphqlClient';
import api from '../core/api';
import config from '../config/config';

export { watchAuthSaga } from '@topconagriculture/auth';
export { watchAuthorizationSaga } from './application/authorization/authorization.saga';
export { watchCommonSaga } from './application/common/common.saga';
export { watchBootstrapSaga } from './application/bootstrap/bootstrap.saga';
export { watchCompanySaga } from './entities/company/company.saga';
export { watchCompanyUserSaga } from './entities/companyUser/company.user.saga';
export { watchUserSaga } from './user/user.saga';
export { watchRouterSaga } from './router/router.saga';
export { watchIngredientSaga } from './entities/ingredients/ingredients.saga';
export { watchPremixesSaga } from './entities/premixes/premixes.saga';
export { watchRecipesSaga } from './entities/recipes/recipes.saga';
export { watchFarmsSaga } from './entities/farms/farms.saga';
export { watchGroupTypesSaga } from './entities/groupType/groupType.saga';
export { watchGroupSaga } from './entities/group/group.saga';
export { watchCodeSaga } from './entities/code/code.saga';
export { watchFeedingSaga } from './entities/feeding/feeding.saga';
export { watchMixersSaga } from './entities/mixers/mixers.saga';
export { watchAppRecipesSaga } from './application/recipes/appRecipes.saga';
export { watchAppFeedGroupsSaga } from './application/groupPreview/groupPreview.saga';
export { watchLoadMixersSaga } from './application/loadMixers/loadMixers.saga';
export { watchAppPremixesSaga } from './application/premixes/appPremixes.saga';
export { watchAppIngredientsSaga } from './application/ingredients/appIngredients.saga';
export { watchScaleTypeSaga } from './entities/scaleType/scaleType.saga';
export { watchReportsSaga } from './entities/reports/reports.saga';
export { watchPresetSaga } from './entities/preset/preset.saga';
export { watchOperatorsSaga } from './entities/operators/operators.saga';
export { watchSharingSaga } from './entities/sharing/sharing.saga';
export { watchSettingsSaga } from './entities/settings/settings.saga';
export { watchNotificationsSaga } from './notifications/notifications.saga';
export { watchDataToolsSaga } from './entities/dataTools/dataTools.saga';
export { watchZonesSaga } from './entities/zones/zones.saga';
export { watchSubscriptionSaga } from './subscription/subscription.saga';
export { watchStorageSaga } from './storage/storage.saga';
export { watchRefusalsSaga } from './entities/refusals/refusals.saga';
export { watchLotsSaga } from './entities/lots/lots.saga';
export { watchRelationsSaga } from './entities/relations/relations.saga';
export { watchLotTypesSaga } from './entities/lotTypes/lotTypes.saga';
export { watchLotMarketTypesSaga } from './entities/lotMarketTypes/lotMarketTypes.saga';
export { watchAppLotsSaga } from './application/lots/appLots.saga';
export { watchHerdManagementSystemSaga } from './entities/hms/hms.saga';
export { watchInventorySaga } from './entities/inventory/inventory.saga';
export { watchAutomatedReportsSaga } from './entities/automatedReports/automatedReports.saga';
export { watchOrdersSaga } from './entities/orders/orders.saga';
export { watchAppOrdersSaga } from './application/ingredientsInOrder/ingredientsInOrder.saga';
export { watchWeighbridgeSaga } from './entities/weighbridge/weighbridge.saga';
export { watchDashboardSaga } from './entities/dashboard/dashboard.saga';
export { watchCostTypesSaga } from './entities/costTypes/costTypes.saga';
export { watchPDFSaga } from './application/pdf/pdf.saga';
export { watchDriverPermissionsSaga } from './entities/driverPermissions/driverPermissions.saga';
export { watchLocationsSaga } from './entities/locations/locations.saga';
export { watBinControlSaga } from './entities/binControl/binControl.saga';

export const watchProfilingSagaConfigured = watchProfilingSaga(gqlInstance, {
  checkAgreements: true,
  serviceAgreementsPageUrl: config.SERVICE_AGREEMENTS_REDIRECT_URL,
});
export const watchCountrySagaConfigured = watchCountrySaga({
  axiosSubscription: api.getSubscriptionInstance(),
  gqlInstance: gqlInstance,
});
export const watchLanguageSagaConfigured = watchLanguageSaga({
  axiosProfileManager: api.getProfileInstance(),
});
